import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["tagIds"],
  _excluded2 = ["accountId"],
  _excluded3 = ["allocationTableId"],
  _excluded4 = ["allocationTableId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { adminApiRoutes } from './routes';
export class AdminApi {
  constructor() {
    _defineProperty(this, "routes", adminApiRoutes);
  }
  async getCompaniesList(body, options) {
    const tagIds = body.tagIds,
      rest = _objectWithoutProperties(body, _excluded);
    const params = new URLSearchParams();
    Object.keys(rest).forEach(function (key) {
      if (rest[key] !== undefined) params.append(key, rest[key] ? rest[key] : '');
    });
    if (tagIds && tagIds.length) {
      tagIds.split('&').map(i => {
        params.append('tagIds', i);
      });
    }
    const resp = await requestService('property').get(this.routes.companies, _objectSpread({
      params: params
    }, options.cancelToken));
    return resp.data;
  }
  async createPMAccount(body, options) {
    const resp = await requestService('auth').post(this.routes.createAccount, _objectSpread({}, body), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createCompany(body, options) {
    const resp = await requestService('property').post(this.routes.companies, _objectSpread({}, body), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCompanyById(data, options) {
    const resp = await requestService('property').get(this.routes.company(data.companyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAdminAccountImpersonate(body, options) {
    const companyId = body.companyId;
    const resp = await requestService('auth').get(this.routes.loginImpersonate({
      companyId
    }), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createAdminAccount(body, options) {
    const resp = await requestService('auth').post(this.routes.baseUrl, _objectSpread(_objectSpread({}, body), options.cancelToken));
    return resp.data;
  }
  async getAdminAccounts(options) {
    const resp = await requestService('auth').get(this.routes.adminAccounts, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteAdminAccount(body, options) {
    const accountId = body.accountId;
    const resp = await requestService('auth').delete(this.routes.deleteAdmin({
      accountId
    }), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async blockAdminAccount(body, options) {
    const resp = await requestService('auth').post(this.routes.blockAdmin(body.accountId), {}, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async unblockAdminAccount(body, options) {
    const resp = await requestService('auth').post(this.routes.unblockAdmin(body.accountId), {}, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateAdminAccount(data, options) {
    const accountId = data.accountId,
      rest = _objectWithoutProperties(data, _excluded2);
    const resp = await requestService('auth').put(this.routes.updateAdmin(accountId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getUtilityCredentials(query, options) {
    // Accepts a bare companyId for the admin surface, or a scoped object for the property surface.
    // Undefined values are dropped rather than sent as "undefined" strings, which the API would try
    // to bind as a Guid and reject with a 400.
    const scoped = typeof query === 'string' ? {
      companyId: query
    } : query;
    const params = scoped ? Object.fromEntries(Object.entries(scoped).filter(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        value = _ref2[1];
      return !!value;
    })) : undefined;
    const resp = await requestService('property').get(this.routes.utilityCredentials, _objectSpread({
      params: params && Object.keys(params).length ? params : undefined
    }, options.cancelToken));
    return resp.data;
  }
  async saveUtilityCredential(body, options) {
    const resp = await requestService('property').post(this.routes.utilityCredentials, body, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getUtilityCredentialEntitlement(companyId, options) {
    const resp = await requestService('property').get(this.routes.utilityCredentialEntitlement, _objectSpread({
      params: {
        companyId
      }
    }, options.cancelToken));
    return resp.data;
  }
  async getBillScrapingHealth(days, options) {
    const resp = await requestService('property').get(this.routes.billScrapingHealth, _objectSpread({
      params: {
        days
      }
    }, options.cancelToken));
    return resp.data;
  }
  async disableUtilityCredential(credentialId, options) {
    await requestService('property').post(this.routes.disableUtilityCredential(credentialId), undefined, _objectSpread({}, options.cancelToken));
  }
  async getBillScrapingCoverage(options) {
    const resp = await requestService('property').get(this.routes.billScrapingCoverage, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getBillScrapingProviders(options) {
    const resp = await requestService('property').get(this.routes.billScrapingProviders, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getBillQueue(query, options) {
    // Falsy values are dropped rather than sent: the API binds `cycleId` as a Guid and rejects an
    // empty string with a 400, and `onlyManual=false` is the default anyway.
    const params = query ? Object.fromEntries(Object.entries(query).filter(_ref3 => {
      let _ref4 = _slicedToArray(_ref3, 2),
        value = _ref4[1];
      return value !== undefined && value !== '' && value !== false;
    })) : undefined;
    const resp = await requestService('property').get(this.routes.billQueue, _objectSpread({
      params: params && Object.keys(params).length ? params : undefined
    }, options.cancelToken));
    return resp.data;
  }
  async getBillQueueCycles(options) {
    const resp = await requestService('property').get(this.routes.billQueueCycles, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async claimBillQueueItem(body, options) {
    const resp = await requestService('property').post(this.routes.billQueueClaim(body.allocationTableId), undefined, _objectSpread({
      params: body.force ? {
        force: true
      } : undefined
    }, options.cancelToken));
    return resp.data;
  }
  async releaseBillQueueItem(allocationTableId, options) {
    const resp = await requestService('property').post(this.routes.billQueueRelease(allocationTableId), undefined, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async setBillQueueState(body, options) {
    const allocationTableId = body.allocationTableId,
      rest = _objectWithoutProperties(body, _excluded3);
    const resp = await requestService('property').post(this.routes.billQueueState(allocationTableId), rest, _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  // Enters the bill through the queue's own endpoint rather than the billing module's, which
  // scopes to the caller's own company. The queue is cross-company by design.
  async enterBillQueueBill(body, options) {
    const allocationTableId = body.allocationTableId,
      rest = _objectWithoutProperties(body, _excluded4);
    const resp = await requestService('property').post(this.routes.billQueueBill(allocationTableId), rest, _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  // One credential, one call. There is deliberately no bulk form of this.
  async revealBillQueueCredential(credentialId, options) {
    const resp = await requestService('property').post(this.routes.billQueueReveal(credentialId), undefined, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}